import { useEffect } from 'react';
import { PROVIDER_BRAND } from '@/data/provider-brand';

/**
 * Sets `document.title` so browser PDF export / save-as uses
 * "Bonum Funding · {company}" instead of the static index.html title.
 */
export function useDeckDocumentTitle(companyName: string | undefined) {
  useEffect(() => {
    if (!companyName) return;
    const previous = document.title;
    document.title = `${PROVIDER_BRAND.companyName} · ${companyName}`;
    return () => {
      document.title = previous;
    };
  }, [companyName]);
}
